<template>
<div>
    <v-pointszkmain v-if="chainId == 324"></v-pointszkmain>
</div>
</template>

<script>
    export default {
        data() {
            return {
                chainId:'',
            }
        },
        mounted(){
            this.chainId = localStorage.getItem('chainId') || 324
            if(this.chainId != 324){
                this.$router.push({path:'/home'})
            }

        },
    }
</script> 